import { type PlacementDetails as AccommodationDetail } from 'src/store/placementDetailsPageSlice/types';
import { type ServiceOptions } from 'src/types';

import rtwClient from '../apiService';

import { type ActivePlacementMetricsResponse } from './types';

class JmrService {
  /**
   * Get accommodation detail
   */
  public async getAccommodationDetail(accommodationId: number) {
    return await rtwClient.get<AccommodationDetail>(`/accommodation/detail/${accommodationId}`);
  }

  /**
   * Get accommodation detail base on austin case and user login
   */
  public async getAccommodationIdByCaseIdAndLogin(type: string, caseId: string, login: string) {
    const res = await rtwClient.get<number>(`/accommodation/type/${type}/caseId/${caseId}/login/${login}`);
    return res;
  }

  /**
   * Delete accommodation
   */
  public async deleteAccommodation(accommodationId: number) {
    return await rtwClient.delete(`/accommodation/${accommodationId}`);
  }

  /**
   * Get accommodation detail
   */
  public async getEmailTemplate() {
    return await rtwClient.get<string>(`/accommodation/emailTemplate/saveAccommodation`, {
      responseType: 'text',
    });
  }

  /**
   * Get active placement metrics for a site, optionally for one source
   */
  public async getActivePlacementMetrics(siteId: number, accommodationType?: string, options?: ServiceOptions) {
    return await rtwClient.get<ActivePlacementMetricsResponse>(`/accommodation/activePlacementMetrics/site/${siteId}`, {
      params: { accommodationType },
      signal: options?.signal,
    });
  }
}

export default new JmrService();
